import styled from 'styled-components';
import { useState } from 'react';
import { Button } from '@prosolve/common-components-ui'
import { getEnv } from '../utils'
import ClueModal from './ClueModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  color: #c7ffff;
  font-size: 48px;
  text-align: center;
`

const CardContainer = styled.div`
  /* padding: 20px; */
  background-color: #ffffff;
  color: #565656;
  border: 1px solid #C2C9D1;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: ${props => props.$noClick ? "default" : "pointer"};
  position: relative;
  // width: 518px;
  // width: 385px;
`

const CardCover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

// const ViewClueCard = styled.div`
//   color: #f85c5c;
//   font-size: 32px;
//   background-color: #0280c6;
//   color: #ffffff;
//   padding: 20px;
//   border-radius: 10px;
// `

const CoverImageWrapper = styled.div`
  /* display: flex; */
`
const CoverImage = styled.img`
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
`

const Badge = styled.div`
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 20px;
  // font-weight: bold;
  flex: 1;
  padding: 4px 10px;
  background: #ffffff;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
`

export default ({
  cardData = {},
  completionInfo = {},
  teamColor,
  teamName,
  setOpenSurveyObj
}) => {

  const {
    title = '',
    name = '',
    assessmentName = '',
    image = ''
  } = cardData;

  const completionInfoObj = completionInfo[assessmentName]

  const completedChallengeNames = Object.keys(completionInfo)

  const isEleanorCard = (name === 'Eleanor the Predictor');
  const isEleanorUnlocked = completedChallengeNames.includes('PD-Challenge1') && completedChallengeNames.includes('PD-Challenge3') && completedChallengeNames.includes('PD-Challenge4');

  const isCompleted = Boolean(completionInfoObj)

  const isEleanorAndLocked = (isEleanorCard && !isEleanorUnlocked);

  const hasSuccessfulCode = Boolean(completionInfoObj && completionInfoObj.codeSuccessful);

  const env = getEnv()
  const linkUrl = `https://go.${env ? `${env}.` : ''}prosolve.com/survey?assessmentName=${assessmentName}${teamColor ? `&teamColor=${teamColor}` : ''}${teamName ? `&teamName=${teamName}` : ''}`

  // const linkUrl = `http://localhost:3000/survey?assessmentName=${assessmentName}${teamColor ? `&teamColor=${teamColor}` : ''}${teamName ? `&teamName=${teamName}` : ''}`

  const onClickLink = () => {
    // const openedTab = // 
    // window.open(linkUrl, '_blank')

    if (!isCompleted && !isEleanorAndLocked) {
      setOpenSurveyObj({ linkUrl })
    }

    // Example of how we can auto close a tab on a timer if desired
    // setTimeout(() => {
    //   openedTab.close()
    // }, 5000)
  }

  const [showClue, setShowClue] = useState(false)

  const baseButtonStyle = {
    padding: '5px 25px',
    fontWeight: 'normal',
    fontSize: '32px',
  }

  return (
    <Container>
      {
        showClue
        &&
        <ClueModal assessmentName={assessmentName} onClose={() => setShowClue(false)} />
      }
      <Title>{title}</Title>
      <CardContainer $noClick={( isCompleted || isEleanorAndLocked )} onClick={onClickLink}>
        { ( isCompleted || isEleanorAndLocked ) && 
          <CardCover>
            <div style={{ fontSize: '48px', color: isEleanorAndLocked ? '#ffffff' : '#f85c5c' }}>
              {isEleanorAndLocked ? 'LEVEL LOCKED' : 'COMPLETED'}
            </div>
             <Button
              style={{ ...baseButtonStyle, visibility: hasSuccessfulCode ? 'visible' : 'hidden' }}
              $colored={true}
              onClick={() => setShowClue(true)}
            >
              {'View Clue Card'}
            </Button>
          </CardCover> 
        }
        <CoverImageWrapper>
          <CoverImage src={image} alt={`image-cover-${name}`}/>
        </CoverImageWrapper>
        { !isEleanorCard &&
          <Badge>
            {name}
          </Badge>
        }
      </CardContainer>
    </Container>
  )
}